import React, { useEffect, useState } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
import { TeacherSidebar } from '../TeacherSidebar';
import { MenuIcon, XIcon } from 'lucide-react';
export const CareersPage = () => {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  // Open sidebar by default on larger screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`} data-id="element-2992">
      <Navbar data-id="element-2993" />

      {/* Mobile sidebar toggle */}
      <button onClick={toggleSidebar} className="lg:hidden fixed bottom-4 right-4 z-30 bg-deep-pink text-white p-3 rounded-full shadow-lg flex items-center justify-center" aria-label={isSidebarOpen ? 'Close menu' : 'Open menu'} style={{
      minWidth: '56px',
      minHeight: '56px'
    }} data-id="element-2994">
        {isSidebarOpen ? <XIcon className="h-6 w-6" data-id="element-2995" /> : <MenuIcon className="h-6 w-6" data-id="element-2996" />}
      </button>

      {/* Left Sidebar */}
      <aside className={`w-64 fixed inset-y-0 pt-20 pb-16 ${isDark ? 'bg-navy-900/90 shadow-lg' : 'bg-white shadow-md'} z-20 transform transition-all duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`} data-id="element-2997">
        <TeacherSidebar darkMode={isDark} closeSidebar={() => setIsSidebarOpen(false)} data-id="element-2998" />
      </aside>

      {/* Main Content */}
      <div className={`pt-20 pb-16 transition-all duration-300 ease-in-out ${isSidebarOpen ? 'lg:ml-64' : 'ml-0 lg:ml-64'}`} data-id="element-2999">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3000">
          <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl shadow-lg p-8 md:p-12`} data-id="element-3001">
            <h1 className={`text-4xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3002">
              Careers at MaestroConnect
            </h1>

            <div className={`prose prose-lg max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-3003">
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3004">
                MaestroConnect is building the future of music education. We're
                a small, focused team working on real infrastructure that helps
                teachers and students connect, learn, and grow.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3005">
                Why Join Us
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-3006">
                We're not chasing trends or building features for the sake of
                features. We're solving real problems for music teachers who
                need better tools to manage their studios and students who want
                a clearer path to improvement.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3007">
                If you care about craft, clarity, and building something that
                actually matters to people, you'll fit in here.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3008">
                What We Value
              </h2>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3009">
                <li data-id="element-3010">
                  <strong data-id="element-3011">Clarity over complexity</strong> — We build tools that
                  are easy to understand and use.
                </li>
                <li data-id="element-3012">
                  <strong data-id="element-3013">Long-term thinking</strong> — We're building
                  infrastructure, not disposable software.
                </li>
                <li data-id="element-3014">
                  <strong data-id="element-3015">Real impact</strong> — We measure success by how much
                  we help teachers and students, not vanity metrics.
                </li>
                <li data-id="element-3016">
                  <strong data-id="element-3017">Craft</strong> — We care about doing things well, not
                  just fast.
                </li>
                <li data-id="element-3018">
                  <strong data-id="element-3019">Focus</strong> — We say no to most things so we can
                  say yes to the right things.
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3020">
                Open Positions
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-3021">
                We're currently a small team and not actively hiring. However,
                if you're exceptional at what you do and believe in what we're
                building, we'd love to hear from you.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-3022">
                Get in Touch
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-3023">
                Send us an email at{' '}
                <a href="mailto:careers@maestroconnect.com" className="text-deep-pink hover:underline" data-id="element-3024">
                  careers@maestroconnect.com
                </a>{' '}
                with:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3025">
                <li data-id="element-3026">What you do and what you're great at</li>
                <li data-id="element-3027">Why you're interested in MaestroConnect</li>
                <li data-id="element-3028">Links to your work (portfolio, GitHub, writing, etc.)</li>
                <li data-id="element-3029">Anything else you think we should know</li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mt-8`} data-id="element-3030">
                We read every email and respond to everyone who takes the time
                to reach out thoughtfully.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Overlay for mobile when sidebar is open */}
      {isSidebarOpen && <div className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-10" onClick={toggleSidebar} aria-hidden="true" data-id="element-3031"></div>}

      <Footer data-id="element-3032" />
    </div>;
};